<template>
    <div class="transfer-default">
        <div class="row">
            <div class="col-12 text-start">
                <page-title
                  :title="'Administratie'"
                  icon="transfer"
                />
            </div>
        </div>

        <nav>
            <ul class="nav nav-underline">
                <li class="nav-item">
                    <router-link
                        class="nav-link"
                        :to="'/transfer/messages'"
                        active="true"
                        exact-active-class="active"
                    >
                       Berichten
                    </router-link>
                </li>
                <li
                    class="nav-item"
                    v-if="!isGastouderapp()"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/news'"
                        exact-active-class="active"
                    >
                        Nieuws
                    </router-link>
                </li>
                <li
                    class="nav-item"
                    v-if="isGastouderapp()"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/filesPersonal'"
                        exact-active-class="active"
                    >
                        Persoonlijke documenten
                    </router-link>
                </li>
                <li
                    class="nav-item"
                    v-if="isGastouderapp()"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/filesGeneral'"
                        exact-active-class="active"
                    >
                        Algemene documenten
                    </router-link>
                </li>
                <li
                    class="nav-item"
                    v-if="this.getApplicationSetting('kdv_personeel') === '1' && !isGastouderapp()"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/reports'"
                        exact-active-class="active"
                    >
                        Rapportages
                    </router-link>
                </li>
                <li
                    class="nav-item"
                    v-if="this.getApplicationSetting('ipad_mutation_overview') === '1' && !isGastouderapp()"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/mutationRequests'"
                        exact-active-class="active"
                    >
                        Aanvragen
                    </router-link>
                </li>
            </ul>
        </nav>

        <div class="py-3">
            <router-view/>
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'

export default {
    name: 'transferDefault',
    components: {
        PageTitle,
    },
    methods: {
       isGastouderapp() {
           return process.env.VUE_APP_BASE === '/gastouderapp/'
       }
    }
}
</script>

<style scoped>

.nav-underline {
    gap: 1.5rem;
    border-bottom: 1px solid rgba(0,0,0,.1);
}
.nav-underline .nav-link {
    padding-right: 0;
    padding-left: 0;
    color: rgba(0,0,0,.5);
    border-bottom: .125rem solid transparent;
}
.nav-underline .nav-link:hover,
.nav-underline .nav-link:focus {
    color: rgba(0,0,0,.7);
    border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
    font-weight: 600;
    color: rgba(0,0,0,.9);
    border-bottom-color: #2479bc;
}

@media only screen and (max-width: 767px) {
    .nav-underline {
        display: block;
        columns: 2;
    }
    .nav-underline .nav-item {
        margin-bottom: 1rem;
    }
    .nav-underline .nav-link {
        padding: .375rem .75rem;
        border: 1px solid rgba(0,0,0,.1);
        border-radius: .25rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .nav-underline .nav-link.active,
    .nav-underline .show > .nav-link {
        border: 1px solid rgba(0,0,0,.5);
    }
}
</style>
